<template>
  <div class="bar" ref="seriesLine" style="height: 100%"></div>
</template>
  
  <script>
export default {
  props: {
    data: Object,
    unit: String,
  },
  mounted() {
    this.draw()
  },
  methods: {
    draw() {
      let myChart = this.$echarts.init(this.$refs.seriesLine)
      let data = []
      let dataAxis
      let unit = this.unit || ''
      let legendName = []
      let series
      if (this.data) {
        dataAxis = this.data.axisData
        this.data.datas.map(t => {
          legendName.push(t.name)
          console.log(this);
          t = {
            ...t,
            itemStyle: {
              color: this.setColor()
            }
          }
          data.push(t)
        })
        series = {
          name: '',
          type: 'bar',
          stack: 'bid',
          emphasis: {
            focus: 'series'
          },
          data: data,
        }
        console.log(legendName, data);
      } else {
        dataAxis = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];
        data = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
      }


      let option = {
        tooltip: {  // 不写会有默认样式
          //   formatter: function (params) {
          //     return `${params.name}: ${params.value}`
          //   }
        },
        legend: {
          show: true,
          //   data: legendName,
          //   right: '10%'
        },
        grid: {
          top: '15%',
          bottom: '10%',
          left: '5%',
          containLabel: true, // 为true时包括刻度标签(所有内容), 防止溢出
        },
        xAxis: {
          data: dataAxis,
          axisLabel: {
            textStyle: {
              color: '#1b3c76',
            },
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#cfcfcf'
            }
          },
          z: 10
        },
        yAxis: {
          name: this.unit || '',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#1b3c76'
            }
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            textStyle: {
              color: '#1b3c76'
            },
            formatter: '{value} '
          },
          // 分割线
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series

      };

      // Enable data zoom when user click bar.
      var zoomSize = 6;
      myChart.on('click', function (params) {
        window.console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
        myChart.dispatchAction({
          type: 'dataZoom',
          startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
          endValue: dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)]
        });
      });

      myChart.setOption(option)
    },
    setColor() {
      return `rgba(${Math.ceil(Math.random() * 200) + 1},${Math.ceil(Math.random() * 256) + 1},${Math.ceil(Math.random() * 256) + 1},${Math.ceil(Math.random() * 11) / 5})`;
    }
  },
}
  </script>
  
  <style lang="scss" scope>
.bar {
  & > div:first-child {
    width: 100% !important;
    height: 100% !important;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
  
  
  